import { jsx as _jsx } from "react/jsx-runtime";
import { InstagramEmbed as Instagram } from 'react-social-media-embed';
export const InstagramEmbed = ({ originalUrl }) => {
    return (_jsx("div", { style: { maxWidth: 500, width: '100%' }, children: _jsx(Instagram, { captioned: false, url: originalUrl, width: "100%" }) }));
};
//# sourceMappingURL=InstagramEmbed.js.map